import * as MUI from "@mui/material";
import { useAppThemeContext } from "../../../../context/ThemeContext";

import BidsLogo from "../../../../assets/bids_logo.png";
import LogoPE from "../../../../assets/logope.png";
import LogoPEbranco from "../../../../assets/logopebranco.png";

export default function Footer() {
  const { themeName } = useAppThemeContext();

  const theme = MUI.useTheme();
  return (
    <MUI.Stack
      pb={1}
      sx={{
        "@media print": {
          overflow: "hidden !important",
          pageBreakInside: "avoid",
        },
      }}
    >
      <MUI.Stack
        width="100%"
        height="2rem"
        bgcolor={theme.palette.primary.light}
      />
      <MUI.Stack
        flexWrap="wrap"
        width="100%"
        flexDirection={["column", "row"]}
        alignItems="center"
        justifyContent="space-between"
        pt={1}
        gap={2}
        pl={3}
        flex={1}
        sx={{
          "@media print": {
            flexDirection: "row",
          },
        }}
      >
        <MUI.Stack flex={1}>
          <img
            width="250"
            height="60"
            src={themeName === "light" ? LogoPE : LogoPEbranco}
            alt="Logo PE"
          />
        </MUI.Stack>
        <MUI.Stack textAlign="center" flex={1}>
          <MUI.Typography
            variant="body2"
            sx={{
              "@media print": {
                fontSize: "12px",
              },
            }}
          >
            Secretaria de Defesa Social
          </MUI.Typography>
          <MUI.Typography
            variant="body2"
            sx={{
              "@media print": {
                fontSize: "12px",
              },
            }}
          >
            Gerência de Tecnologia da Informação
          </MUI.Typography>
          <MUI.Typography
            variant="body2"
            sx={{
              "@media print": {
                fontSize: "12px",
              },
            }}
          >
            Rua São Geraldo, 111, Santo Amaro, Recife - PE. CEP 50040-020
          </MUI.Typography>
        </MUI.Stack>
        <MUI.Stack alignItems="center" flex={1}>
          <MUI.Typography
            variant="body2"
            sx={{
              "@media print": {
                fontSize: "12px",
              },
            }}
          >
            Este sistema faz parte do
          </MUI.Typography>
          <img
            width="70"
            height="70"
            src={BidsLogo}
            alt="Logo do rodapé com o símbolo de Pernambuco"
          />
        </MUI.Stack>
      </MUI.Stack>
    </MUI.Stack>
  );
}
